import React,{ useState, useEffect } from 'react';

function TVAccountSetup() {

    return (
        <div id="modem-setup-component" className="modem-setup-component modem-connectivity-component">
            <h2>Setting Up Your Start TV Account</h2>

            
            <p style={{ fontSize:'0.9rem' }}>After connecting your set-top box, follow the steps below and Start TV will be ready in about 5 minutes.</p>
            <ul>
                <li>Turn on TV and set-top box</li>
                <li>Press OK to pair your remote and set-top box</li>
                <li>Select your language from the list provided</li>
                <li>Set up TV with an Android phone or tablet (optional)</li>
                <li>Select Wi-Fi connection</li>
                <li>Sign in to Google account (optional)</li>
                <li>Accept Google Terms of Service</li>
                <li>Accept Google Location services (optional)</li>
                <li>Send diagnostic information to Android (optional)</li>
                <li>Choose a name for your set-top box</li>
                <li>Set up your remote to work with your TV</li>
                <li>Complete volume test to test pairing</li>
                <li>Android TV feature review</li>
                <li>Sign in to Start TV</li>
            </ul>

            <h4 style={{ marginTop:'2rem' }}>Ways to Your Optimize Your Start TV Experience</h4>
            <div style={{ fontWeight:600, marginTop:'1rem' }}>Your Start TV</div>
            <ol>
                <li>For the best TV experience, it is recommended the Set Top Boxes are direct connected whenever possible</li>
                <li>If you are experiencing freezing or buffering, and a direct connection is not possible, we recommend connecting your Set Top Box to the 5 Ghz network.</li>
            </ol>

            <p style={{ fontSize:'0.9rem' }}>If that does not resolve it, run the StartCARE app and contact our Support Team at <a href="tel:1-866-668-0001">1-866-668-0001</a></p>

            <div style={{ fontWeight:600, marginTop:'2rem' }}>Google Play Account</div>
            <p style={{ fontSize:'0.9rem' }}>We highly recommend signing into a Google Play account on the Set Top Box to ensure the Start TV app will remain up to date, it’s also the best way to ensure a great Start TV experience.</p>
            <span>Ready to sign in? Here’s how:</span>
            <ol>
                <li>Click the Home button on the remote control</li>
                <li>Select Settings</li>
                <li>Click Accounts and Sign In</li>
                <li>If you see an account already attached, you don’t need to look any further. Otherwise you will be brought to the Google Sign in Page</li>
                <li>Select Sign In</li>
                <li>You will see two options: (1) Use Your Phone or Computer (2) Use Your Remote. Once you have logged into your Google Play Account using either of the above options you are all set</li>
            </ol>
        </div>
    )
}

export default TVAccountSetup